<div class="sub-list-manager">
    @if (listConfig) {
        <ng-container
            *ngComponentOutlet="listManagerType; inputs: { config: listConfig }"
        ></ng-container>
    }
</div>
